import React, { Component } from "react";
import axios from "axios";
import LeftSideNavigation from "../../../../vendorDashboardComponents/navigationSection/LeftSideNavigation";
import HomeReusableTopBarNavigation from "../../../superAdminReusable/superAdminHomeButton/HomeReusableTopBarNavigation";
import { TopTextReusableComponent } from "../../../../vendorOnboradingComponents/reusableOnboardingComponent/TopTextReusable/TopTextReusableComponent";
import { Form } from "react-bootstrap";
import Switch from "react-switch";
import { withRouter } from "react-router-dom";
import { MainSubscriptionHome } from "./MainSubscriptionHome";
import { SeatingArea } from "./InsidePageComponent/SeatingArea";
import { MainSubscriptionScreen } from "./InsidePageComponent/MainSubscriptionScreen";
import { OrderingScreen } from "./InsidePageComponent/OrderingScreen";
import WalkinWaitlist from "./InsidePageComponent/WalkinWaitlist";
import ReservationScreen from "./InsidePageComponent/ReservationScreen";
import MenuSetupScreen from "./InsidePageComponent/MenuSetupScreen";
import FastFoodMenuSetupScreen from "./InsidePageComponent/FastFoodMenuSetupScreen";
import { InsideSeating } from "./InsidePageComponent/InsideSeating";
import SimpleReactLightbox from "simple-react-lightbox";

import PropTypes from "prop-types";
import { connect } from "react-redux";
import { clear_all_errors } from "../../../../../store/actions/errorActions";
import { superadmin_create_and_update_restaurant } from "../../../../../store/actions/SuperAdminActions/adminNewVendorOnboard";
import isEmpty from "../../../../../store/validation/is-Empty";
import { AmealioLoader } from "../../../../Loader/AmealioLoader";
import MultipleImageUploadComponent from "../../../../reusableComponents/imageUploadReusableComponent/MultipleImageUploadComponent";
import Alert from "react-s-alert";
import { serverApi } from "../../../../../config/Keys";

export class SuperAdminVendorSubscription extends Component {
  constructor(props) {
    super(props);
    this.state = {
      actionButton: false,
      loader: false,
      seatingAreaLoder: false,
      casualDiningMenuLoader: false,
      fastFoodMenuLoader: false,
      hasSetSubscriptionProps: false,
      openModal: false,
      openSuccessModal: false,
      checked: false,
      selectedTab: 4,
      displayHomeScreen: false,
      displayCasualFineAndFastFood: false,

      // Display Page Screen

      displaySeating: false,
      displayScanAndPay: false,
      displayMenuSetup: false,
      displayOrdering: false,
      displayFoodMenuSetup: false,
      displayFoodOrdering: false,
      displayInsideScreen: false,
      displayWalkinWaitlist: false,
      displayReservations: false,

      // toggle Click State
      seatingArea: false,
      scanAndPay: false,
      menuSetup: false,
      ordering: false,
      foodMenuSetup: false,
      foodOrdering: false,
      walkinWaitlist: false,
      reservation: false,
      takeAway: false,
      selfServe: false,
      driveThru: false,
      curbSide: false,
      //Seating State
      displayScreen: false,
      all_seating_area: [],
      selected_seating_area: [{ id: 1 }],
      uploadMenu: [],
      highchair: false,
      handicapAccess: false,
      roomNumberSeatingRequest: false,
      tableManagement: false,
      seatingCapacity: "",
      autoAcceptPaxLimit: "",
      tableturnAroundTime: "",
      reservationTableAroundTime: false,
      reservationTableAroundTimeText: "",
      //Walkin Waitlist States
      distance: "",
      requestPeriod: "",
      minimumPerson: "",
      walkinWaitlistTableKeptForPopup: false,
      walkinWaitlistTableKeptFor: "",
      //Reservation State
      minimumPersonReservation: "",
      reservationTableKeptForPopup: false,
      reservationTableKeptFor: "",
      sameDayAllowed: false,
      reservationMinLead: false,
      reservationMinLeadTime: "",
      reservationCutOffTime: false,
      reservationCutOffTimeText: "",
      maximumDays: "",
      reservationCapacity: "",
      reservationTimeSlots: false,
      reservationTimeSlotsText: "",
      //Casual Dining Upload Menu
      casualDiningUploadMenu: [],
      //Fast Food Upload Menu
      fastFoodUploadMenu: [],

      errors: {},

      resTabKeptForError: false,
      resMinLeadTimeError: false,
      resCutOffTimeError: false,
      resTimeSlotError: false,
      walkinWaitlistError: false,
    };
    this.displaySeatingArea = this.displaySeatingArea.bind(this);
    this.handleSeatingArea = this.handleSeatingArea.bind(this);

    this.handleChangeScanAndPay = this.handleChangeScanAndPay.bind(this);

    this.displayMenuSetup = this.displayMenuSetup.bind(this);
    this.handleMenuSetup = this.handleMenuSetup.bind(this);

    this.displayOrdering = this.displayOrdering.bind(this);
    this.handleOrdering = this.handleOrdering.bind(this);
    this.handleChangeTakeAway = this.handleChangeTakeAway.bind(this);
    this.handleChangeSelfServe = this.handleChangeSelfServe.bind(this);
    this.handleChangeDriveThru = this.handleChangeDriveThru.bind(this);
    this.handleChangeCurbSide = this.handleChangeCurbSide.bind(this);

    this.displayFoodMenuSetup = this.displayFoodMenuSetup.bind(this);
    this.handleFoodMenuSetup = this.handleFoodMenuSetup.bind(this);
    this.displayFoodOrdering = this.displayFoodOrdering.bind(this);
    this.handleFoodOrdering = this.handleFoodOrdering.bind(this);

    this.displayWalkinWaitlist = this.displayWalkinWaitlist.bind(this);
    this.handleWalkinWaitlist = this.handleWalkinWaitlist.bind(this);
    this.displayReservations = this.displayReservations.bind(this);
    this.handleReservation = this.handleReservation.bind(this);

    /************** Seating Page Condition  **************/
    this.onDrop = this.onDrop.bind(this);
    this.handleChangehighchair = this.handleChangehighchair.bind(this);
    this.handleChangehandicapAccess =
      this.handleChangehandicapAccess.bind(this);
    this.handleChangeroomNumberSeatingRequest =
      this.handleChangeroomNumberSeatingRequest.bind(this);
    this.handleChangetableManagement =
      this.handleChangetableManagement.bind(this);
    /************** Reservation ***************/
    this.sameDayAllowed = this.sameDayAllowed.bind(this);
    /************** Casual Dining Upload Menu ***************/
    this.casualDining = this.casualDining.bind(this);
    /************** Fast Food Upload Menu ***************/
    this.fastFoodUploadMenu = this.fastFoodUploadMenu.bind(this);
  }

  componentDidMount() {
    if (this.props.auth.loader) {
      this.setState({
        loader: this.props.auth.loader,
      });
    }
  }

  static getDerivedStateFromProps(nextProps, nextState) {
    if (
      !isEmpty(nextProps.onboarding._id) &&
      !isEmpty(nextProps.subscription) &&
      !nextState.hasSetSubscriptionProps
    ) {
      let selected_seating_area = nextProps.onboarding.selected_seating_area;
      if (!isEmpty(selected_seating_area[0])) {
        if (
          isEmpty(selected_seating_area[0]._id) &&
          selected_seating_area.length > 0
        ) {
          selected_seating_area = nextProps.subscription.filter((seating) =>
            selected_seating_area.includes(seating._id)
          );
        }
      }
      return {
        all_seating_area: nextProps.subscription,
        displayHomeScreen: !isEmpty(
          nextProps.onboarding.display_subscription_home
        )
          ? nextProps.onboarding.display_subscription_home
          : false,
        seatingArea: !isEmpty(nextProps.onboarding.seating_area)
          ? nextProps.onboarding.seating_area
          : false,
        menuSetup: !isEmpty(nextProps.onboarding.ordering)
          ? nextProps.onboarding.ordering
          : false,
        // ordering: !isEmpty(nextProps.onboarding.ordering)
        //   ? nextProps.onboarding.ordering
        //   : false,
        foodMenuSetup: !isEmpty(nextProps.onboarding.food_menu_setup)
          ? nextProps.onboarding.food_menu_setup
          : false,
        foodOrdering: !isEmpty(nextProps.onboarding.food_ordering)
          ? nextProps.onboarding.food_ordering
          : false,
        // displayScreen: nextProps.onboarding.displayScreen,
        displaySeating: !isEmpty(nextProps.onboarding.displayScreen)
          ? nextProps.onboarding.displayScreen
          : false,
        // menu_setup: nextProps.onboarding.// menu_setup,
        selected_seating_area: !isEmpty(
          nextProps.onboarding.selected_seating_area
        )
          ? nextProps.onboarding.selected_seating_area
          : [],
        highchair: !isEmpty(nextProps.onboarding.highchair)
          ? nextProps.onboarding.highchair
          : false,
        handicapAccess: !isEmpty(nextProps.onboarding.handicap)
          ? nextProps.onboarding.handicap
          : false,
        roomNumberSeatingRequest: !isEmpty(nextProps.onboarding.room_number)
          ? nextProps.onboarding.room_number
          : false,
        tableManagement: !isEmpty(nextProps.onboarding.table_management)
          ? nextProps.onboarding.table_management
          : false,
        seatingCapacity: !isEmpty(nextProps.onboarding.seating_capacity)
          ? nextProps.onboarding.seating_capacity
          : "",
        autoAcceptPaxLimit: !isEmpty(nextProps.onboarding.auto_accept_pax)
          ? nextProps.onboarding.auto_accept_pax
          : "",
        tableturnAroundTime: !isEmpty(nextProps.onboarding.table_turn_around)
          ? nextProps.onboarding.table_turn_around
          : "",
        walkinWaitlist: !isEmpty(nextProps.onboarding.walk_in_or_waitlist)
          ? nextProps.onboarding.walk_in_or_waitlist
          : false,
        reservation: !isEmpty(nextProps.onboarding.reservation)
          ? nextProps.onboarding.reservation
          : false,
        distance: !isEmpty(nextProps.onboarding.distance)
          ? nextProps.onboarding.distance
          : "",
        requestPeriod: !isEmpty(nextProps.onboarding.request_period)
          ? nextProps.onboarding.request_period
          : "",
        minimumPerson: !isEmpty(nextProps.onboarding.minimum_person)
          ? nextProps.onboarding.minimum_person
          : "",
        walkinWaitlistTableKeptFor: !isEmpty(
          nextProps.onboarding.walk_in_wait_list_table_kept_for
        )
          ? nextProps.onboarding.walk_in_wait_list_table_kept_for
          : "",
        minimumPersonReservation: !isEmpty(
          nextProps.onboarding.minimum_person_reservation
        )
          ? nextProps.onboarding.minimum_person_reservation
          : "",
        reservationTableKeptFor: !isEmpty(
          nextProps.onboarding.reservation_table_kept_for
        )
          ? nextProps.onboarding.reservation_table_kept_for
          : "",
        sameDayAllowed: !isEmpty(nextProps.onboarding.sameDayAllowed)
          ? nextProps.onboarding.sameDayAllowed
          : false,
        reservationMinLeadTime: !isEmpty(nextProps.onboarding.minimum_lead_time)
          ? nextProps.onboarding.minimum_lead_time
          : "",
        reservationCutOffTimeText: !isEmpty(nextProps.onboarding.cut_off_time)
          ? nextProps.onboarding.cut_off_time
          : "",
        maximumDays: !isEmpty(nextProps.onboarding.maximum_days)
          ? nextProps.onboarding.maximum_days
          : "",
        reservationCapacity: !isEmpty(nextProps.onboarding.reservation_capacity)
          ? nextProps.onboarding.reservation_capacity
          : "",
        reservationTimeSlotsText: !isEmpty(
          nextProps.onboarding.reservation_time_slot
        )
          ? nextProps.onboarding.reservation_time_slot
          : "",
        uploadMenu: !isEmpty(nextProps.onboarding.seatingAreaMenu)
          ? nextProps.onboarding.seatingAreaMenu
          : [],
        casualDiningUploadMenu: !isEmpty(nextProps.onboarding.casualDiningMenu)
          ? nextProps.onboarding.casualDiningMenu
          : [],
        fastFoodUploadMenu: !isEmpty(nextProps.onboarding.fastFoodMenu)
          ? nextProps.onboarding.fastFoodMenu
          : [],
        hasSetSubscriptionProps: true,
      };
    }
    if (nextProps.errors !== nextState.errors) {
      return {
        errors: nextProps.errors,
      };
    }
    if (nextProps.auth.loader !== nextState.loader) {
      // console.log(nextProps.auth.loader);
      return {
        loader: nextProps.auth.loader,
      };
    }
    return null;
  }

  /*****************************************
   * @DESC Open Terms and Conditions Popup
   ****************************************/
  handleChecked = (e) => {
    this.setState({
      checked: !this.state.checked,
      actionButton: true,
    });
  };
  onOpenModal = (e) => {
    // e.preventDefault();
    this.setState({ openModal: true });
  };
  onCloseModal = (e) => {
    this.setState({ openModal: false, checked: false });
  };

  onOpenModalSuccessClick = (e) => {
    e.preventDefault();
    this.setState({
      openSuccessModal: true,
    });
  };
  onClosedModalSuccessClick = (e) => {
    this.setState({
      openSuccessModal: false,
      openModal: false,
      checked: false,
    });
  };

  /***************************************
   * @DESC Display Food Ordering Page Toggle Handlers
   **************************************/
  displayFoodOrdering(displayFoodOrdering) {
    this.setState({
      displayFoodOrdering,
    });
  }
  handleFoodOrdering(foodOrdering) {
    this.setState({
      foodOrdering,
    });
  }

  /***************************************
   * @DESC Seating Area Toggle Handlers
   **************************************/
  displaySeatingArea(displaySeating) {
    this.setState({
      displaySeating,
    });
  }

  handleSeatingArea(seatingArea) {
    this.setState({
      seatingArea,
      displayScreen: false,
      walkinWaitlist: this.state.walkinWaitlist === false ? false : true,
      reservation: this.state.reservation === false ? false : true,
    });
  }

  onSeatingChangeHandler = (e) => {
    this.setState({
      displaySeating: false,
      displayCasualFineAndFastFood: false,
    });
  };
  onSeatingAreaSubmit = (e) => {
    this.setState({
      displaySeating: false,
      displayInsideScreen: true,
      seatingArea: true,
    });
  };

  /***************************************
   * @DESC Scan And Pay Toggle Handlers
   **************************************/
  handleChangeScanAndPay(scanAndPay) {
    this.setState({
      scanAndPay,
    });
  }

  /***************************************
   * @DESC Display Menu Setup Toggle Handlers
   **************************************/
  displayMenuSetup(displayMenuSetup) {
    this.setState({
      displayMenuSetup,
    });
  }
  handleMenuSetup(menuSetup) {
    this.setState({
      menuSetup,
    });
  }
  onMenuSetupChangeHandler = (e) => {
    this.setState({
      displayMenuSetup: false,
      displayCasualFineAndFastFood: false,
    });
  };
  onMenuSetupSubmit = (e) => {
    this.setState({
      displayMenuSetup: false,
      displayCasualFineAndFastFood: false,
      menuSetup: true,
    });
  };

  /***************************************
   * @DESC Display Ordering Page Toggle Handlers
   **************************************/
  displayOrdering(displayOrdering) {
    this.setState({
      displayOrdering,
    });
  }
  handleOrdering(ordering) {
    this.setState({
      ordering,
    });
  }
  onOrderingSetupChangeHandler = (e) => {
    this.setState({
      displayOrdering: false,
      displayCasualFineAndFastFood: false,
    });
  };
  onOrderingPageSubmit = (e) => {
    this.setState({
      displayOrdering: false,
      displayCasualFineAndFastFood: false,
      ordering: true,
    });
  };

  /***************************************
   * @DESC OrderingScreen Toggle Handlers
   **************************************/
  handleChangefoodMenuSetup(foodMenuSetup) {
    this.setState({
      foodMenuSetup,
    });
  }
  handleChangefoodOrdering(foodOrdering) {
    this.setState({
      foodOrdering,
    });
  }

  handleChangeTakeAway(takeAway) {
    this.setState({
      takeAway,
    });
  }
  handleChangeSelfServe(selfServe) {
    this.setState({
      selfServe,
    });
  }
  handleChangeDriveThru(driveThru) {
    this.setState({
      driveThru,
    });
  }
  handleChangeCurbSide(curbSide) {
    this.setState({
      curbSide,
    });
  }

  /***************************************
   * @DESC Display Food Menu Setup Toggle Handlers
   **************************************/
  displayFoodMenuSetup(displayFoodMenuSetup) {
    this.setState({
      displayFoodMenuSetup,
    });
  }
  handleFoodMenuSetup(foodMenuSetup) {
    this.setState({
      foodMenuSetup,
    });
  }
  onFoodMenuSetupChangeHandler = (e) => {
    this.setState({
      displayFoodMenuSetup: false,
      displayCasualFineAndFastFood: true,
    });
  };
  onFoodMenuSetupSubmit = (e) => {
    this.setState({
      displayFoodMenuSetup: false,
      displayCasualFineAndFastFood: true,
      foodMenuSetup: true,
    });
  };

  /***************************************
   * @DESC Display Food Ordering Page Toggle Handlers
   **************************************/
  // displayFoodOrdering(displayFoodOrdering) {
  //   this.setState({
  //     displayFoodOrdering,
  //   });
  // }
  // handleFoodOrdering(foodOrdering) {
  //   this.setState({
  //     foodOrdering,
  //   });
  // }
  onFoodOrderingSetupChangeHandler = (e) => {
    this.setState({
      displayOrdering: false,
      displayCasualFineAndFastFood: true,
    });
  };
  onFoodOrderingPageSubmit = (e) => {
    this.setState({
      displayOrdering: false,
      displayCasualFineAndFastFood: true,
      foodOrdering: true,
    });
  };

  /***************************************
   * @DESC Walkin Waitlist Toggle Handlers
   **************************************/
  displayWalkinWaitlist(displayWalkinWaitlist) {
    this.setState({
      displayWalkinWaitlist,
    });
  }
  handleWalkinWaitlist(walkinWaitlist) {
    this.setState({
      walkinWaitlist,
    });
  }
  onWalkinWaitlistChangeHandler = (e) => {
    this.setState({
      displayWalkinWaitlist: false,
      displayInsideScreen: true,
    });
  };
  onWalkinWaitlistAreaSubmit = (e) => {
    this.setState({
      displayWalkinWaitlist: false,
      displayInsideScreen: true,
      walkinWaitlist: true,
    });
  };

  /***************************************
   * @DESC Reservation Toggle Handlers
   **************************************/
  displayReservations(displayReservations) {
    this.setState({
      displayReservations,
    });
  }
  handleReservation(reservation) {
    this.setState({
      reservation,
    });
  }
  onReservationsChangeHandler = (e) => {
    this.setState({
      displayReservations: false,
      displayInsideScreen: true,
    });
  };
  onReservationsSubmit = (e) => {
    this.setState({
      displayReservations: false,
      displayInsideScreen: true,
      reservation: true,
    });
  };

  /************************************
   * @DESC Display home screen and Toggle Button Screen
   ************************************/
  onBackButton = (history) => (e) => {
    e.preventDefault();
    //console.log("hii");
    const data = {
      dataOne: 3,
    };
    history.push({
      pathname: "/bankdetailshome",
      state: { data: data },
    });
  };

  onScreenChangeHandler = (e) => {
    this.setState({
      displayHomeScreen: true,
      displayCasualFineAndFastFood: false,
    });
  };
  onPageChangeHandlerClosed = (e) => {
    this.setState({
      displayHomeScreen: false,
    });
  };

  onOrderingChangeHandlerClosed = (e) => {
    this.setState({
      displayOrdering: false,
    });
  };
  onTogglePageDisplay = (e) => {
    this.setState({
      displayCasualFineAndFastFood: !this.state.displayCasualFineAndFastFood,
    });
  };

  insideSeatingChangeHandler = (e) => {
    this.setState({
      displayInsideScreen: false,
      displayHomeScreen: true,
      // displayCasualFineAndFastFood: false,
    });
  };
  onClickInsideSettingsSubmit = (e) => {
    this.setState({
      displayInsideScreen: false,
      displayHomeScreen: true,
      seatingArea: true,
    });
  };

  /****************************************************************
   * @DESC Seating Area Page All Functions Start
   ****************************************************************/
  /**************************
   * @DESC - Current and Saving HANDLER
   ***************************/
  handleChangehighchair(highchair) {
    this.setState({
      highchair,
    });
  }
  handleChangehandicapAccess(handicapAccess) {
    this.setState({
      handicapAccess,
    });
  }
  handleChangeroomNumberSeatingRequest(roomNumberSeatingRequest) {
    this.setState({
      roomNumberSeatingRequest,
    });
  }
  handleChangetableManagement(tableManagement) {
    this.setState({
      tableManagement,
    });
  }

  onChange = (e) => {
    const { value, maxLength } = e.target;
    const number = value.slice(0, maxLength);
    this.setState({
      [e.target.name]: number,
      errors: {},
      actionButton: true,
    });
  };

  onFocusOut = (e) => {
    const { errors } = this.state;
    if (e.target.value === "") {
      errors[e.target.name] = `${e.target.name} is required`;
    } else {
      errors[e.target.name] = "";
    }
    this.setState({
      errors: errors,
      actionButton: true,
    });
  };

  /*********************************************
   * @DESC Reservation Table Around Time Model
   ********************************************/

  reservationTableAroundTimeOpen = () => {
    this.setState({
      reservationTableAroundTime: true,
    });
  };

  reservationTableAroundTimeClosed = () => {
    this.setState({
      reservationTableAroundTime: false,
    });
  };

  reservationTableAroundTimeTextButtonClick = (e, type) => {
    e.preventDefault();
    this.setState({
      tableturnAroundTime: type,
      reservationTableAroundTime: false,
    });
  };

  onClickDisplayScreen = (e) => {
    e.preventDefault();
    this.setState({
      displayScreen: true,
    });
  };
  onClickDisplayScreenClosed = (e) => {
    e.preventDefault();
    this.setState({
      displayScreen: false,
    });
  };

  /*********************************************
   * @DESC - onLocated Inside Array Selector
   *********************************************/
  onLocatedInsideArraySelector = (icon) => (e) => {
    e.preventDefault();
    let restaurantTypeArray = this.state.selected_seating_area;
    if (restaurantTypeArray.length === 0) {
      restaurantTypeArray.push(icon);
    } else {
      let isAlreadyPresent = restaurantTypeArray.includes(icon);
      if (isAlreadyPresent) {
        let indexOf = restaurantTypeArray.indexOf(icon);
        if (indexOf === 0 || indexOf) {
          restaurantTypeArray.splice(indexOf, 1);
        }
      } else {
        restaurantTypeArray.push(icon);
      }
    }
    this.setState({
      selected_seating_area: restaurantTypeArray,
      actionButton: true,
    });
  };

  /*********************************
   * @DESC Multiple Image Upload
   ********************************/
  onDrop(picture) {
    this.setState({
      uploadMenu: picture,
      actionButton: true,
    });
  }

  /****************************************************************
   * @DESC Seating Area Page All Functions End
   ****************************************************************/

  /****************************************************************
   * @DESC Walkin Waitlist Page All Functions Start
   ****************************************************************/
  onChangeWalkinWaitlist = (e) => {
    let { value, min, max, maxLength } = e.target;
    value =
      Math.max(Number(min), Math.min(Number(max), Number(value))) ||
      value.slice(0, maxLength);
    this.setState({
      [e.target.name]: value,
      errors: {},
      actionButton: true,
    });
  };

  /************************************
   * @DESC Walkin Waitlist Table Kept for Model
   ***********************************/
  walkinWaitlistTableKeptOpen = () => {
    this.setState({
      walkinWaitlistError: true,
      walkinWaitlistTableKeptForPopup: true,
    });
  };

  walkinWaitlistTableKeptClosed = () => {
    this.setState({
      walkinWaitlistError: true,
      walkinWaitlistTableKeptForPopup: false,
    });
  };

  walkinWaitlistTableKeptButtonClick = (e, type) => {
    e.preventDefault();
    this.setState({
      walkinWaitlistTableKeptFor: type,
      walkinWaitlistTableKeptForPopup: false,
      walkinWaitlistError: false,
    });
  };

  /****************************************************************
   * @DESC Walkin Waitlist Page All Functions End
   ****************************************************************/

  /****************************************************************
   * @DESC Reservation Page All Functions start
   ****************************************************************/
  sameDayAllowed(sameDayAllowed) {
    this.setState({
      sameDayAllowed,
    });
  }

  /************************************
   * @DESC Reservation Table Kept for Model
   ***********************************/

  reservationTableKeptOpen = () => {
    this.setState({
      resTabKeptForError: true,
      reservationTableKeptForPopup: true,
    });
  };

  reservationTableKeptClosed = () => {
    this.setState({
      resTabKeptForError: true,
      reservationTableKeptForPopup: false,
    });
  };

  reservationTableKeptButtonClick = (e, type) => {
    e.preventDefault();
    this.setState({
      reservationTableKeptFor: type,
      reservationTableKeptForPopup: false,
      resTabKeptForError: false,
    });
  };

  /************************************
   * @DESC Reservation Min Lead Model
   ***********************************/

  reservationMinLeadOpen = () => {
    this.setState({
      resMinLeadTimeError: true,
      reservationMinLead: true,
    });
  };

  reservationMinLeadClosed = () => {
    this.setState({
      resMinLeadTimeError: true,
      reservationMinLead: false,
    });
  };

  reservationMinLeadTimeButtonClick = (e, type) => {
    e.preventDefault();
    this.setState({
      reservationMinLeadTime: type,
      reservationMinLead: false,
      resMinLeadTimeError: false,
    });
  };

  /************************************
   * @DESC Reservation Cut Off Time Model
   ***********************************/

  reservationCutOffTimeOpen = () => {
    this.setState({
      resCutOffTimeError: true,
      reservationCutOffTime: true,
    });
  };

  reservationCutOffTimeClosed = () => {
    this.setState({
      resCutOffTimeError: true,
      reservationCutOffTime: false,
    });
  };

  reservationCutOffTimeButtonClick = (e, type) => {
    e.preventDefault();
    this.setState({
      reservationCutOffTimeText: type,
      reservationCutOffTime: false,
      resCutOffTimeError: false,
    });
  };

  /************************************
   * @DESC Reservation Time Slots Model
   ***********************************/

  reservationTimeSlotsOpen = () => {
    this.setState({
      resTimeSlotError: true,
      reservationTimeSlots: true,
    });
  };

  reservationTimeSlotsClosed = () => {
    this.setState({
      resTimeSlotError: true,
      reservationTimeSlots: false,
    });
  };

  reservationTimeSlotsButtonClick = (e, type) => {
    e.preventDefault();
    this.setState({
      reservationTimeSlotsText: type,
      reservationTimeSlots: false,
      resTimeSlotError: false,
    });
  };

  /****************************************************************
   * @DESC Reservation Page All Functions End
   ****************************************************************/
  /*********************************
   * @DESC Casual Dining Multiple Image Upload
   ********************************/
  casualDining(picture) {
    this.setState({
      casualDiningUploadMenu: picture,
    });
  }
  /*********************************
   * @DESC Fast Food Multiple Image Upload
   ********************************/
  fastFoodUploadMenu(picture) {
    this.setState({
      fastFoodUploadMenu: picture,
    });
  }

  /*************************************
   * @DESC Multiple Seating Menu Image Upload
   ************************************/
  seatingMenuUploadMultipleFiles = (e) => {
    // this.setState({ seatingAreaLoder: true });
    const vendor_id = this.props.onboarding.vendor_id;
    const restaurant_name = this.props.onboarding.restaurant_name
      .split(" ")
      .join("");
    const combined = vendor_id + "_" + restaurant_name;
    const data = new FormData();
    let flag = false;
    for (let i = 0; i < e.target.files.length; i++) {
      let allPicures = this.state.uploadMenu;
      allPicures.some((phone) => {
        if (phone.split(`${restaurant_name}-`)[1] === e.target.files[i].name) {
          flag = true;
        }
      });
      if (!flag) {
        data.append("files", e.target.files[i]);
      }
    }
    if (!flag) {
      axios
        .post(`${serverApi}/upload-assets?uploadSide=${combined}`, data)
        .then((res) => {
          let oldData = this.state.uploadMenu;
          let newData = res.data;
          let mergedData = oldData.concat(newData);
          this.setState({
            uploadMenu: mergedData,
            // seatingAreaLoder: false,
            actionButton: true,
          });
          Alert.success(`<h4>Menu Image Upload Successfully</h4>`, {
            position: "top-right",
            effect: "bouncyflip",
            beep: true,
            html: true,
            timeout: 3000,
            offset: 35,
          });
        })
        .catch((err) => {
          // this.setState({ seatingAreaLoder: false });
          Alert.error(`<h4>${err}</h4>`, {
            position: "top-right",
            effect: "bouncyflip",
            beep: true,
            html: true,
            timeout: 3000,
            offset: 35,
          });
        });
    } else {
      // this.setState({ seatingAreaLoder: false });
      Alert.error(`<h4>Can not upload the same image</h4>`, {
        position: "top-right",
        effect: "bouncyflip",
        beep: true,
        html: true,
        timeout: 3000,
        offset: 35,
      });
    }
  };

  seatingMenuMultipleRemove = (indexId) => (e) => {
    let allUploadMenu = this.state.uploadMenu;
    let allUploadMenuObj = allUploadMenu.find(
      (images, index) => index === indexId
    );
    if (allUploadMenuObj === 0 || allUploadMenuObj) {
      allUploadMenu.splice(allUploadMenu.indexOf(allUploadMenuObj), 1);
      this.setState({ allUploadMenu: allUploadMenu, actionButton: true });
    }
  };

  /*************************************
   * @DESC Multiple Causual Food Menu Image Upload
   ************************************/
  causualFoodUploadMultipleFiles = (e) => {
    // this.setState({ casualDiningMenuLoader: true });
    const vendor_id = this.props.onboarding.vendor_id;
    const restaurant_name = this.props.onboarding.restaurant_name
      .split(" ")
      .join("");
    const combined = vendor_id + "_" + restaurant_name;
    const data = new FormData();
    let flag = false;
    for (let i = 0; i < e.target.files.length; i++) {
      let allPicures = this.state.casualDiningUploadMenu;
      allPicures.some((phone) => {
        if (phone.split(`${restaurant_name}-`)[1] === e.target.files[i].name) {
          flag = true;
        }
      });
      if (!flag) {
        data.append("files", e.target.files[i]);
      }
    }
    if (!flag) {
      axios
        .post(`${serverApi}/upload-assets?uploadSide=${combined}`, data)
        .then((res) => {
          let oldData = this.state.casualDiningUploadMenu;
          let newData = res.data;
          let mergedData = oldData.concat(newData);
          this.setState({
            casualDiningUploadMenu: mergedData,
            // casualDiningMenuLoader: false,
            actionButton: true,
          });
          Alert.success(`<h4>Menu Image Upload Successfully</h4>`, {
            position: "top-right",
            effect: "bouncyflip",
            beep: true,
            html: true,
            timeout: 3000,
            offset: 35,
          });
        })
        .catch((err) => {
          // this.setState({ casualDiningMenuLoader: false });
          Alert.error(`<h4>${err}</h4>`, {
            position: "top-right",
            effect: "bouncyflip",
            beep: true,
            html: true,
            timeout: 3000,
            offset: 35,
          });
        });
    } else {
      // this.setState({ casualDiningMenuLoader: false });
      Alert.error(`<h4>Can not upload the same image</h4>`, {
        position: "top-right",
        effect: "bouncyflip",
        beep: true,
        html: true,
        timeout: 3000,
        offset: 35,
      });
    }
  };

  causualFoodMultipleRemove = (indexId) => (e) => {
    let allCasualDiningUploadMenu = this.state.casualDiningUploadMenu;
    let allCasualDiningUploadMenuObj = allCasualDiningUploadMenu.find(
      (images, index) => index === indexId
    );
    if (allCasualDiningUploadMenuObj === 0 || allCasualDiningUploadMenuObj) {
      allCasualDiningUploadMenu.splice(
        allCasualDiningUploadMenu.indexOf(allCasualDiningUploadMenuObj),
        1
      );
      this.setState({
        allCasualDiningUploadMenu: allCasualDiningUploadMenu,
        actionButton: true,
      });
    }
  };

  /*************************************
   * @DESC Multiple Fast Food Menu Image Upload
   ************************************/
  fastFoodUploadMultipleFiles = (e) => {
    // this.setState({ fastFoodMenuLoader: true });
    const vendor_id = this.props.onboarding.vendor_id;
    const restaurant_name = this.props.onboarding.restaurant_name
      .split(" ")
      .join("");
    const combined = vendor_id + "_" + restaurant_name;
    const data = new FormData();
    let flag = false;
    for (let i = 0; i < e.target.files.length; i++) {
      let allPicures = this.state.fastFoodUploadMenu;
      allPicures.some((phone) => {
        if (phone.split(`${restaurant_name}-`)[1] === e.target.files[i].name) {
          flag = true;
        }
      });
      if (!flag) {
        data.append("files", e.target.files[i]);
      }
    }
    if (!flag) {
      axios
        .post(`${serverApi}/upload-assets?uploadSide=${combined}`, data)
        .then((res) => {
          let oldData = this.state.fastFoodUploadMenu;
          let newData = res.data;
          let mergedData = oldData.concat(newData);
          this.setState({
            fastFoodUploadMenu: mergedData,
            // fastFoodMenuLoader: false,
            actionButton: true,
          });
          Alert.success(`<h4>Menu Image Upload Successfully</h4>`, {
            position: "top-right",
            effect: "bouncyflip",
            beep: true,
            html: true,
            timeout: 3000,
            offset: 35,
          });
        })
        .catch((err) => {
          // this.setState({ fastFoodMenuLoader: false });
          Alert.error(`<h4>${err}</h4>`, {
            position: "top-right",
            effect: "bouncyflip",
            beep: true,
            html: true,
            timeout: 3000,
            offset: 35,
          });
        });
    } else {
      // this.setState({ fastFoodMenuLoader: false });
      Alert.error(`<h4>Can not upload the same image</h4>`, {
        position: "top-right",
        effect: "bouncyflip",
        beep: true,
        html: true,
        timeout: 3000,
        offset: 35,
      });
    }
  };

  fastFoodMultipleRemove = (indexId) => (e) => {
    let allFastFoodUploadMenu = this.state.fastFoodUploadMenu;
    let allFastFoodUploadMenuObj = allFastFoodUploadMenu.find(
      (images, index) => index === indexId
    );
    if (allFastFoodUploadMenuObj === 0 || allFastFoodUploadMenuObj) {
      allFastFoodUploadMenu.splice(
        allFastFoodUploadMenu.indexOf(allFastFoodUploadMenuObj),
        1
      );
      this.setState({
        allFastFoodUploadMenu: allFastFoodUploadMenu,
        actionButton: true,
      });
    }
  };

  onHandleSubmit = (e) => {
    e.preventDefault();
    if (this.props.onboarding._id && this.props.onboarding.vendor_id) {
      const formData = {
        vendor_id: this.props.onboarding.vendor_id,
        id: this.props.onboarding._id,
        display_subscription_home: this.state.displayHomeScreen,
        seating_area: this.state.seatingArea,
        ordering: this.state.menuSetup,
        // ordering: this.state.ordering,
        food_menu_setup: this.state.foodMenuSetup,
        food_ordering: this.state.foodOrdering,
        displayScreen: this.state.displayScreen,
        selected_seating_area: this.state.selected_seating_area,
        // menu_setup: this.state.uploadMenu,
        highchair: this.state.highchair,
        handicap: this.state.handicapAccess,
        room_number: this.state.roomNumberSeatingRequest,
        table_management: this.state.tableManagement,
        seating_capacity: this.state.seatingCapacity,
        auto_accept_pax: this.state.autoAcceptPaxLimit,
        table_turn_around: this.state.tableturnAroundTime,
        walk_in_or_waitlist: this.state.walkinWaitlist,
        reservation: this.state.reservation,
        distance: this.state.distance,
        request_period: this.state.requestPeriod,
        minimum_person: this.state.minimumPerson,
        walk_in_wait_list_table_kept_for: this.state.walkinWaitlistTableKeptFor,
        minimum_person_reservation: this.state.minimumPersonReservation,
        reservation_table_kept_for: this.state.reservationTableKeptFor,
        sameDayAllowed: this.state.sameDayAllowed,
        minimum_lead_time: this.state.reservationMinLeadTime,
        cut_off_time: this.state.reservationCutOffTimeText,
        maximum_days: this.state.maximumDays,
        reservation_capacity: this.state.reservationCapacity,
        reservation_time_slot: this.state.reservationTimeSlotsText,
        page_completed_till: 22,
        seatingAreaMenu: this.state.uploadMenu,
        casualDiningMenu: this.state.casualDiningUploadMenu,
        fastFoodMenu: this.state.fastFoodUploadMenu,
      };
      // console.log(formData);
      this.props.superadmin_create_and_update_restaurant(formData);
      this.onOpenModal();
    }
  };

  renderToggleButtonScreen = () => {
    const {
      seatingArea,
      menuSetup,
      // ordering,
      foodMenuSetup,
      // foodOrdering,
      displaySeating,
      displayMenuSetup,
      displayOrdering,
      displayFoodMenuSetup,
      displayFoodOrdering,
      displayCasualFineAndFastFood,
      displayInsideScreen,
    } = this.state;
    if (displaySeating === true) {
      return this.renderSeatingScreen();
    } else if (displayMenuSetup === true) {
      return this.renderMenuSetupScreen();
    } else if (displayOrdering === true) {
      return this.renderOrderingScreen();
    } else if (displayFoodMenuSetup === true) {
      return this.renderImageUploadScreen();
    } else if (displayFoodOrdering === true) {
      return this.renderFastFoodOrderingScreen();
    } else if (displayInsideScreen === true) {
      return this.renderInsideSeating();
    } else {
      return (
        <React.Fragment>
          <MainSubscriptionScreen
            open={this.state.openModal}
            onOpenModal={this.onHandleSubmit}
            onCloseModal={this.onCloseModal}
            successPopupClick={this.onOpenModalSuccessClick}
            successPopupOpenModal={this.state.openSuccessModal}
            onCloseModalSuccess={this.onClosedModalSuccessClick}
            handleChecked={this.handleChecked}
            termsConditionDisabled={this.state.checked}
            onPageChangeHandlerClosed={this.onPageChangeHandlerClosed}
            onClick={this.onTogglePageDisplay}
            displayScreen={displayCasualFineAndFastFood}
            seatingAreaButton={this.state.seatingArea}
            scanAndPayButton={this.state.scanAndPay}
            menuSetupButton={this.state.menuSetup}
            orderingButton={this.state.ordering}
            foodMenuSetupButton={this.state.foodMenuSetup}
            foodOrderingButton={this.state.foodOrdering}
            walkinWaitlistButton={this.state.walkinWaitlist}
            reservationButton={this.state.reservation}
            takeAwayButton={this.state.takeAway}
            selfServeButton={this.state.selfServe}
            driveThruButton={this.state.driveThru}
            curbSideButton={this.state.curbSide}
            seating={
              seatingArea === false ? (
                <Switch
                  checked={this.state.displaySeating}
                  onChange={this.displaySeatingArea}
                  onColor="#59f832"
                  onHandleColor="#ffffff"
                  handleDiameter={23}
                  uncheckedIcon={false}
                  checkedIcon={false}
                  boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                  activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                  height={26}
                  width={55}
                  id="material-switch"
                />
              ) : (
                <Switch
                  checked={this.state.seatingArea}
                  onChange={this.handleSeatingArea}
                  onColor="#59f832"
                  onHandleColor="#ffffff"
                  handleDiameter={23}
                  uncheckedIcon={false}
                  checkedIcon={false}
                  boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                  activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                  height={26}
                  width={55}
                  id="material-switch"
                />
              )
            }
            // scanAndPay={
            //   <Switch
            //     checked={this.state.scanAndPay}
            //     onChange={this.handleChangeScanAndPay}
            //     onColor="#59F832"
            //     onHandleColor="#ffffff"
            //     uncheckedIcon={false}
            //     checkedIcon={false}
            //     boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
            //     activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
            //     className="react-switch"
            //     id="material-switch"
            //   />
            // }
            menuSetup={
              menuSetup === false ? (
                <Switch
                  checked={this.state.displayMenuSetup}
                  onChange={this.displayMenuSetup}
                  onColor="#59f832"
                  onHandleColor="#ffffff"
                  handleDiameter={23}
                  uncheckedIcon={false}
                  checkedIcon={false}
                  boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                  activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                  height={26}
                  width={55}
                  id="material-switch"
                />
              ) : (
                <Switch
                  checked={this.state.menuSetup}
                  onChange={this.handleMenuSetup}
                  onColor="#59f832"
                  onHandleColor="#ffffff"
                  handleDiameter={23}
                  uncheckedIcon={false}
                  checkedIcon={false}
                  boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                  activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                  height={26}
                  width={55}
                  id="material-switch"
                />
              )
            }
            ordering={
              // ordering === false ?
              <Switch
                checked={this.state.displayOrdering}
                // onChange={this.displayOrdering}
                onChange={(e) => {
                  console.log("Ordering");
                }}
                disabled={true}
                onColor="#59f832"
                onHandleColor="#ffffff"
                handleDiameter={23}
                uncheckedIcon={false}
                checkedIcon={false}
                boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                height={26}
                width={55}
                id="material-switch"
              />
            }
            fastFoodMenuSetup={
              foodMenuSetup === false ? (
                <Switch
                  checked={this.state.displayFoodMenuSetup}
                  onChange={this.displayFoodMenuSetup}
                  onColor="#59F832"
                  onHandleColor="#ffffff"
                  uncheckedIcon={false}
                  checkedIcon={false}
                  boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                  activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                  className="react-switch"
                  id="material-switch"
                />
              ) : (
                <Switch
                  checked={this.state.foodMenuSetup}
                  onChange={this.handleFoodMenuSetup}
                  onColor="#59F832"
                  onHandleColor="#ffffff"
                  uncheckedIcon={false}
                  checkedIcon={false}
                  boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                  activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                  className="react-switch"
                  id="material-switch"
                />
              )
            }
            fastFoodOrdering={
              // foodOrdering === false ? (
              <Switch
                checked={this.state.displayFoodOrdering}
                // onChange={this.displayFoodOrdering}
                onChange={() => {}}
                disabled={true}
                onColor="#59F832"
                onHandleColor="#ffffff"
                uncheckedIcon={false}
                checkedIcon={false}
                boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                className="react-switch"
                id="material-switch"
              />
              // ) : (
              //   <Switch
              //     checked={this.state.foodOrdering}
              //     onChange={this.handleFoodOrdering}
              //     onColor="#59F832"
              //     onHandleColor="#ffffff"
              //     uncheckedIcon={false}
              //     checkedIcon={false}
              //     boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
              //     activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
              //     className="react-switch"
              //     id="material-switch"
              //   />
              // )
            }
            onsubmitData={this.onHandleSubmit}
          />
        </React.Fragment>
      );
    }
  };

  renderSeatingScreen = () => {
    return (
      <React.Fragment>
        <div className="subscription_component_onboarding_main">
          <SeatingArea
            onSeatingChangeHandler={this.onSeatingChangeHandler}
            seatingAreaScreenNext={this.onSeatingAreaSubmit}
            displayScreen={this.state.displayScreen}
            state={this.state}
            onLocatedInsideArraySelector={this.onLocatedInsideArraySelector}
            onDrop={this.onDrop}
            onClickDisplayScreen={this.onClickDisplayScreen}
            onClickDisplayScreenClosed={this.onClickDisplayScreenClosed}
            handleChangehighchair={this.handleChangehighchair}
            handleChangehandicapAccess={this.handleChangehandicapAccess}
            handleChangeroomNumberSeatingRequest={
              this.handleChangeroomNumberSeatingRequest
            }
            handleChangetableManagement={this.handleChangetableManagement}
            onFocusOut={this.onFocusOut}
            onChange={this.onChange}
            errors={this.state.errors}
            reservationTableAroundTimeOpen={this.reservationTableAroundTimeOpen}
            reservationTableAroundTimeClosed={
              this.reservationTableAroundTimeClosed
            }
            reservationTableAroundTimeTextButtonClick={
              this.reservationTableAroundTimeTextButtonClick
            }
            children={
              <SimpleReactLightbox>
                <MultipleImageUploadComponent
                  title="Upload Documents*"
                  smallTitle="(Upload Your Restaurant Menu)"
                  onChange={this.seatingMenuUploadMultipleFiles}
                  stateValue={this.state.uploadMenu}
                  removeImage={this.seatingMenuMultipleRemove}
                  loader={this.state.seatingAreaLoder}
                  accept="image/gif,image/jpeg,image/jpg,image/png,.pdf"
                />
              </SimpleReactLightbox>
            }
          />
        </div>
      </React.Fragment>
    );
  };

  renderMenuSetupScreen = () => {
    return (
      <React.Fragment>
        <div className="subscription_component_onboarding_main">
          <MenuSetupScreen
            onPageChangeHandlerClosed={this.onMenuSetupChangeHandler}
            onMenuSetupSubmit={this.onMenuSetupSubmit}
            // onDrop={this.casualDining}
            children={
              <SimpleReactLightbox>
                <MultipleImageUploadComponent
                  title="Upload Documents*"
                  smallTitle="(Upload Your Restaurant Menu)"
                  onChange={this.causualFoodUploadMultipleFiles}
                  stateValue={this.state.casualDiningUploadMenu}
                  removeImage={this.causualFoodMultipleRemove}
                  loader={this.state.casualDiningMenuLoader}
                  accept="image/gif,image/jpeg,image/jpg,image/png,.pdf"
                />
              </SimpleReactLightbox>
            }
          />
        </div>
      </React.Fragment>
    );
  };

  renderImageUploadScreen = () => {
    return (
      <React.Fragment>
        <div className="subscription_component_onboarding_main">
          <FastFoodMenuSetupScreen
            onPageChangeHandlerClosed={this.onFoodMenuSetupChangeHandler}
            onMenuSetupSubmit={this.onFoodMenuSetupSubmit}
            // onDrop={this.fastFoodUploadMenu}
            children={
              <SimpleReactLightbox>
                <MultipleImageUploadComponent
                  title="Upload Documents*"
                  smallTitle="(Upload Your Restaurant Menu)"
                  onChange={this.fastFoodUploadMultipleFiles}
                  stateValue={this.state.fastFoodUploadMenu}
                  removeImage={this.fastFoodMultipleRemove}
                  loader={this.state.fastFoodMenuLoader}
                  accept="image/gif,image/jpeg,image/jpg,image/png,.pdf"
                />
              </SimpleReactLightbox>
            }
          />
        </div>
      </React.Fragment>
    );
  };

  renderOrderingScreen = () => {
    const { displayCasualFineAndFastFood, foodMenuSetup, foodOrdering } =
      this.state;
    return (
      <React.Fragment>
        <OrderingScreen
          onPageChangeHandlerClosed={this.onOrderingSetupChangeHandler}
          onClick={this.onTogglePageDisplay}
          displayScreen={displayCasualFineAndFastFood}
          onOrderingPageSubmit={this.onOrderingPageSubmit}
          takeAway={
            <Switch
              checked={this.state.takeAway}
              onChange={this.handleChangeTakeAway}
              onColor="#59F832"
              onHandleColor="#ffffff"
              uncheckedIcon={false}
              checkedIcon={false}
              boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
              activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
              className="react-switch"
              id="material-switch"
            />
          }
          dinein={
            <Switch
              checked={this.state.selfServe}
              onChange={this.handleChangeSelfServe}
              onColor="#59F832"
              onHandleColor="#ffffff"
              uncheckedIcon={false}
              checkedIcon={false}
              boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
              activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
              className="react-switch"
              id="material-switch"
            />
          }
          curbside={
            <Switch
              checked={this.state.driveThru}
              onChange={this.handleChangeDriveThru}
              onColor="#59F832"
              onHandleColor="#ffffff"
              uncheckedIcon={false}
              checkedIcon={false}
              boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
              activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
              className="react-switch"
              id="material-switch"
            />
          }
          driveThru={
            <Switch
              checked={this.state.curbSide}
              onChange={this.handleChangeCurbSide}
              onColor="#59F832"
              onHandleColor="#ffffff"
              uncheckedIcon={false}
              checkedIcon={false}
              boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
              activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
              className="react-switch"
              id="material-switch"
            />
          }
          ImageUpload={
            foodMenuSetup === false ? (
              <Switch
                checked={this.state.displayFoodMenuSetup}
                onChange={this.displayFoodMenuSetup}
                onColor="#59F832"
                onHandleColor="#ffffff"
                uncheckedIcon={false}
                checkedIcon={false}
                boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                className="react-switch"
                id="material-switch"
              />
            ) : (
              <Switch
                checked={this.state.foodMenuSetup}
                onChange={this.handleFoodMenuSetup}
                onColor="#59F832"
                onHandleColor="#ffffff"
                uncheckedIcon={false}
                checkedIcon={false}
                boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                className="react-switch"
                id="material-switch"
              />
            )
          }
          fastFoodOrdering={
            foodOrdering === false ? (
              <Switch
                checked={this.state.displayFoodOrdering}
                onChange={this.displayFoodOrdering}
                onColor="#59F832"
                onHandleColor="#ffffff"
                uncheckedIcon={false}
                checkedIcon={false}
                boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                className="react-switch"
                id="material-switch"
              />
            ) : (
              <Switch
                checked={this.state.foodOrdering}
                onChange={this.handleFoodOrdering}
                onColor="#59F832"
                onHandleColor="#ffffff"
                uncheckedIcon={false}
                checkedIcon={false}
                boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                className="react-switch"
                id="material-switch"
              />
            )
          }
        />
      </React.Fragment>
    );
  };

  renderFastFoodOrderingScreen = () => {
    const { displayCasualFineAndFastFood } = this.state;
    return (
      <React.Fragment>
        <OrderingScreen
          onPageChangeHandlerClosed={this.onFoodOrderingSetupChangeHandler}
          onClick={this.onTogglePageDisplay}
          displayScreen={displayCasualFineAndFastFood}
          onOrderingPageSubmit={this.onFoodOrderingPageSubmit}
          takeAway={
            <Switch
              checked={this.state.takeAway}
              onChange={this.handleChangeTakeAway}
              onColor="#59F832"
              onHandleColor="#ffffff"
              uncheckedIcon={false}
              checkedIcon={false}
              boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
              activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
              className="react-switch"
              id="material-switch"
            />
          }
          dinein={
            <Switch
              checked={this.state.selfServe}
              onChange={this.handleChangeSelfServe}
              onColor="#59F832"
              onHandleColor="#ffffff"
              uncheckedIcon={false}
              checkedIcon={false}
              boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
              activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
              className="react-switch"
              id="material-switch"
            />
          }
          curbside={
            <Switch
              checked={this.state.driveThru}
              onChange={this.handleChangeDriveThru}
              onColor="#59F832"
              onHandleColor="#ffffff"
              uncheckedIcon={false}
              checkedIcon={false}
              boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
              activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
              className="react-switch"
              id="material-switch"
            />
          }
          driveThru={
            <Switch
              checked={this.state.curbSide}
              onChange={this.handleChangeCurbSide}
              onColor="#59F832"
              onHandleColor="#ffffff"
              uncheckedIcon={false}
              checkedIcon={false}
              boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
              activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
              className="react-switch"
              id="material-switch"
            />
          }
          ImageUpload={
            <Switch
              checked={this.state.foodMenuSetup}
              onChange={this.handleChangefoodMenuSetup}
              onColor="#59F832"
              onHandleColor="#ffffff"
              uncheckedIcon={false}
              checkedIcon={false}
              boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
              activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
              className="react-switch"
              id="material-switch"
            />
          }
          fastFoodOrdering={
            <Switch
              checked={this.state.foodOrdering}
              onChange={this.handleChangefoodOrdering}
              onColor="#59F832"
              onHandleColor="#ffffff"
              uncheckedIcon={false}
              checkedIcon={false}
              boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
              activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
              className="react-switch"
              id="material-switch"
            />
          }
        />
      </React.Fragment>
    );
  };

  renderInsideSeating = () => {
    const {
      displayWalkinWaitlist,
      displayReservations,
      walkinWaitlist,
      reservation,
      foodMenuSetup,
      foodOrdering,
    } = this.state;
    if (displayWalkinWaitlist === true) {
      return this.renderWalkinWaitlist();
    } else if (displayReservations === true) {
      return this.renderReservationsScreen();
    } else {
      return (
        <React.Fragment>
          <div className="subscription_component_onboarding_main">
            <InsideSeating
              displayScreen={this.state.displayCasualFineAndFastFood}
              onInsideSeatingChangeHandler={this.insideSeatingChangeHandler}
              onClickInsideSettings={this.onClickInsideSettingsSubmit}
              WalkinWaitlist={
                walkinWaitlist === false ? (
                  <Switch
                    checked={this.state.displayWalkinWaitlist}
                    onChange={this.displayWalkinWaitlist}
                    onColor="#59f832"
                    onHandleColor="#ffffff"
                    handleDiameter={23}
                    uncheckedIcon={false}
                    checkedIcon={false}
                    boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                    activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                    height={26}
                    width={55}
                    id="material-switch"
                  />
                ) : (
                  <Switch
                    checked={this.state.walkinWaitlist}
                    onChange={this.handleWalkinWaitlist}
                    onColor="#59f832"
                    onHandleColor="#ffffff"
                    handleDiameter={23}
                    uncheckedIcon={false}
                    checkedIcon={false}
                    boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                    activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                    height={26}
                    width={55}
                    id="material-switch"
                  />
                )
              }
              Reservation={
                reservation === false ? (
                  <Switch
                    checked={this.state.displayReservations}
                    onChange={this.displayReservations}
                    onColor="#59f832"
                    onHandleColor="#ffffff"
                    handleDiameter={23}
                    uncheckedIcon={false}
                    checkedIcon={false}
                    boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                    activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                    height={26}
                    width={55}
                    id="material-switch"
                  />
                ) : (
                  <Switch
                    checked={this.state.reservation}
                    onChange={this.handleReservation}
                    onColor="#59f832"
                    onHandleColor="#ffffff"
                    handleDiameter={23}
                    uncheckedIcon={false}
                    checkedIcon={false}
                    boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                    activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                    height={26}
                    width={55}
                    id="material-switch"
                  />
                )
              }
              ImageUpload={
                foodMenuSetup === false ? (
                  <Switch
                    checked={this.state.foodMenuSetup}
                    onChange={this.displayFoodMenuSetup}
                    onColor="#59f832"
                    onHandleColor="#ffffff"
                    handleDiameter={23}
                    uncheckedIcon={false}
                    checkedIcon={false}
                    boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                    activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                    height={26}
                    width={55}
                    id="material-switch"
                  />
                ) : (
                  <Switch
                    checked={this.state.foodMenuSetup}
                    onChange={this.handleFoodMenuSetup}
                    onColor="#59f832"
                    onHandleColor="#ffffff"
                    handleDiameter={23}
                    uncheckedIcon={false}
                    checkedIcon={false}
                    boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                    activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                    height={26}
                    width={55}
                    id="material-switch"
                  />
                )
              }
              fastFoodOrdering={
                foodOrdering === false ? (
                  <Switch
                    checked={this.state.foodOrdering}
                    onChange={this.displayFoodOrdering}
                    onColor="#59f832"
                    onHandleColor="#ffffff"
                    handleDiameter={23}
                    uncheckedIcon={false}
                    checkedIcon={false}
                    boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                    activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                    height={26}
                    width={55}
                    id="material-switch"
                  />
                ) : (
                  <Switch
                    checked={this.state.foodOrdering}
                    onChange={this.handleFoodMenuSetup}
                    onColor="#59f832"
                    onHandleColor="#ffffff"
                    handleDiameter={23}
                    uncheckedIcon={false}
                    checkedIcon={false}
                    boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                    activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                    height={26}
                    width={55}
                    id="material-switch"
                  />
                )
              }
            />
          </div>
        </React.Fragment>
      );
    }
  };

  renderWalkinWaitlist = () => {
    return (
      <React.Fragment>
        <div className="subscription_component_onboarding_main">
          <WalkinWaitlist
            onWalkinWaitlistChangeHandler={this.onWalkinWaitlistChangeHandler}
            onClickWalkinSubmit={this.onWalkinWaitlistAreaSubmit}
            state={this.state}
            onChange={this.onChangeWalkinWaitlist}
            onFocusOut={this.onFocusOut}
            walkinWaitlistTableKeptOpen={this.walkinWaitlistTableKeptOpen}
            walkinWaitlistTableKeptClosed={this.walkinWaitlistTableKeptClosed}
            walkinWaitlistTableKeptButtonClick={
              this.walkinWaitlistTableKeptButtonClick
            }
            errors={this.state.errors}
          />
        </div>
      </React.Fragment>
    );
  };
  renderReservationsScreen = () => {
    return (
      <React.Fragment>
        <div className="subscription_component_onboarding_main">
          <ReservationScreen
            onReservationChangeHandler={this.onReservationsChangeHandler}
            onReservationSubmit={this.onReservationsSubmit}
            state={this.state}
            errors={this.state.errors}
            onChange={this.onChangeWalkinWaitlist}
            onFocusOut={this.onFocusOut}
            reservationTableKeptOpen={this.reservationTableKeptOpen}
            reservationTableKeptClosed={this.reservationTableKeptClosed}
            reservationTableKeptButtonClick={
              this.reservationTableKeptButtonClick
            }
            sameDayAllowed={this.sameDayAllowed}
            reservationMinLeadOpen={this.reservationMinLeadOpen}
            reservationMinLeadClosed={this.reservationMinLeadClosed}
            reservationMinLeadTimeButtonClick={
              this.reservationMinLeadTimeButtonClick
            }
            reservationCutOffTimeOpen={this.reservationCutOffTimeOpen}
            reservationCutOffTimeClosed={this.reservationCutOffTimeClosed}
            reservationCutOffTimeButtonClick={
              this.reservationCutOffTimeButtonClick
            }
            reservationTimeSlotsOpen={this.reservationTimeSlotsOpen}
            reservationTimeSlotsClosed={this.reservationTimeSlotsClosed}
            reservationTimeSlotsButtonClick={
              this.reservationTimeSlotsButtonClick
            }
          />
        </div>
      </React.Fragment>
    );
  };

  render() {
    if (this.state.loader) {
      return (
        <React.Fragment>
          <AmealioLoader />
        </React.Fragment>
      );
    }
    const { displayHomeScreen } = this.state;
    return (
      <React.Fragment>
        <div className="container-fluid">
          <div className="row">
            <div className="left-side-panel">
              <LeftSideNavigation displayLink={1} />
            </div>
            <div className="super-admin-right-side-panel">
              <HomeReusableTopBarNavigation />
              <div className="col-12 pl-5 pr-5">
                <div className="super_admin_add_vendor mb-4">
                  <h5 className="main_header_text">Add Vendor</h5>
                  <h4 className="font_20_m">Step : 22</h4>
                  <h4 className="font_20_m c_red mt-2 mb-1">Subscription</h4>
                  <hr className="hr_line" />
                </div>
                <div className="mb-4">
                  <TopTextReusableComponent
                    headingText="Subscription"
                    headingParagraph="Enter the information about the subscription you are interested in for your Business type"
                  />
                </div>
                {displayHomeScreen === true ? (
                  <Form noValidate>
                    <div className="onboarding_process_screen-left-mapinside p-0">
                      {this.renderToggleButtonScreen()}
                    </div>
                  </Form>
                ) : (
                  <div>
                    <div className="onboarding_process_screen-left-mapinside">
                      <MainSubscriptionHome
                        onClick={this.onScreenChangeHandler}
                        backButton={this.onBackButton(this.props.history)}
                      />
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

SuperAdminVendorSubscription.propTypes = {
  onboarding: PropTypes.object.isRequired,
  auth: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  errors: state.errors.errors,
  onboarding: state.superAdminOnboarding.restaurantDetails,
  subscription: state.category.seating_area,
});

export default connect(mapStateToProps, {
  clear_all_errors,
  superadmin_create_and_update_restaurant,
})(withRouter(SuperAdminVendorSubscription));
